export const AUTH_USER_INFO = "auth.userInfo";